/**
 * @file palettes.js
 * @description Catálogo de las paletas candidatas y de los modos claro/oscuro.
 *
 * ⚠ TEMPORAL. Existe para que el equipo y los clientes prueben las tres
 * propuestas en la app real. Cuando se elija una, esto desaparece junto con el
 * resto de `src/theme/`.
 *
 * Los valores de color NO viven aquí: viven en `tokens.css`. Este archivo solo
 * describe qué paletas hay y qué tokens mostrar como muestra en el selector,
 * para que la interfaz nunca tenga un hex escrito a mano.
 */

/** Valor guardado en localStorage. Prefijo `evazard_` como el resto del proyecto. */
export const THEME_STORAGE_KEY = 'evazard_theme';

export const DEFAULT_PALETTE = 'a';
export const DEFAULT_MODE = 'system';

/**
 * Paletas disponibles. `labelKey`/`taglineKey` son claves de i18n; los `swatches`
 * son nombres de tokens CSS que el selector pinta como muestras de color.
 */
export const PALETTES = [
  {
    id: 'a',
    labelKey: 'appearance.palettes.a.name',
    taglineKey: 'appearance.palettes.a.tagline',
    swatches: [
      '--ev-brand-700', '--ev-brand-500', '--ev-accent-500',
      '--ev-success-700', '--ev-warning-700', '--ev-danger-700',
    ],
  },
  {
    id: 'b',
    labelKey: 'appearance.palettes.b.name',
    taglineKey: 'appearance.palettes.b.tagline',
    swatches: [
      '--ev-brand-950', '--ev-brand-800', '--ev-brand-600', '--ev-accent-500',
      '--ev-success-700', '--ev-danger-700',
    ],
  },
  {
    id: 'c',
    labelKey: 'appearance.palettes.c.name',
    taglineKey: 'appearance.palettes.c.tagline',
    swatches: [
      '--ev-brand-700', '--ev-accent-500', '--ev-neutral-50',
      '--ev-neutral-200', '--ev-success-700', '--ev-danger-700',
    ],
  },
];

export const PALETTE_IDS = PALETTES.map((p) => p.id);

/** Modos de apariencia. `system` sigue la preferencia del sistema operativo. */
export const MODES = [
  { id: 'system', labelKey: 'appearance.modes.system', icon: 'bi-circle-half' },
  { id: 'light', labelKey: 'appearance.modes.light', icon: 'bi-sun' },
  { id: 'dark', labelKey: 'appearance.modes.dark', icon: 'bi-moon-stars' },
];

export const MODE_IDS = MODES.map((m) => m.id);

export const isValidPalette = (value) => PALETTE_IDS.includes(value);
export const isValidMode = (value) => MODE_IDS.includes(value);
